<script>
import TreeNode from './tree-node.vue'

class Node {
  constructor(data, tree, level) {
    const { label, children, id } = tree.props
    this.visible = true
    this.expanded = false
    this.data = data
    this.label = data[label]
    this.id = data[id]
    this.level = level
    if (Array.isArray(data[children])) {
      this.childNodes = data[children].map(it => {
        return new Node(it, tree, level + 1)
      })
    }
  }
  expand () {
    this.expanded = true
  }
  collapse () {
    this.expanded = false
  }
}

class Tree {
  constructor(options) {
    this.props = options.props
    this.root = {}
    this.root.childNodes = options.data.map(it => {
      return new Node(it, this, 1)
    })
  }
}

export default {
  name: 'tree',
  components: {
    TreeNode
  },
  props: {
    data: Array,
    props: {
      default: () => {
        return {
          label: 'label',
          children: 'children',
          id: 'id'
        }
      }
    },
    accordion: {
      default: false
    },
    indent: {
      default: 18
    }
  },
  data () {
    return {
      store: null,
      root: null
    }
  },
  created () {
    this.store = new Tree({
      data: this.data,
      props: this.props,
      nodeKey: this.nodeKey
    })
    this.root = this.store.root
  }
}
</script>

<template>
  <div class="tree_container">
    <TreeNode v-for="node in root.childNodes" :key="node.id" :node="node"/>
  </div>
</template>

<style lang="stylus">
.tree_container
  font-size 14px
</style>
